<template>
  <div class="friends row justify-content-center">
    <div class="col-md-8">
        <div class="row">
            <div class="col-sm-7">
                <h2>Organisationer</h2>
            </div>
        </div>
        <table class="table table-bordered table-striped">
            <thead>
                <tr>
                    <th>Namn</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(organisation, index) in organisations">
                    <router-link tag="td" active-class="active" :to="'/organisation/' + organisation.id" exact>
                        <a>{{ organisation.name }}</a>
                    </router-link>
                </tr>
            </tbody>
        </table>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'organisations',
    computed: {
        organisations () {
            return this.$store.state.organisations.organisations
        }
    },
    data () {
        return {
        }
    },
    mounted () {
        this.refresh()
    },
    methods: {
        ...mapActions({
            refresh: 'organisation_list'
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Organisations.vue